import logger from '@/lib/logger';

export const requestInterceptHandler = (config) => {
  if (
    typeof location !== 'undefined' &&
    !config.baseURL?.includes(location.host)
  ) {
    logger.debug(
      `${location.host}|${config.baseURL}|process.env.HOST is incorrect`
    );
    const error = new Error('process.env.HOST is incorrect');
    return Promise.reject(error);
  }

  return config;
};

export const responseInterceptErrorHandler = (error) => {
  errorHandler(error);
  throw error;
};

export const errorHandler = (error) => {
  if (
    error.response &&
    error.response.data &&
    error.response.data.error_code == 20002 &&
    error.response.data.stack.indexOf('MYIAccountNotFoundError') > -1
  ) {
    logger.service({
      url: error.response.config?.url,
      message: `myi error response`,
      data: error.response.data,
      status: error.response.status,
      headers: error.response.headers,
    });
  } else if (error.response) {
    logger.service({
      url: error.response.config?.url,
      params: error.response.config?.params,
      message:
        error.response?.statusText || `Request made and server responded`,
      data: error.response.data,
      status: error.response.status,
    });
  } else {
    logger.error(`Error: ${error.message || error?.toString()}`);
  }
};

export const addDelayOnBuild = (delay = 500) => {
  if (!process.env.IS_BUILD) {
    return;
  }

  return new Promise((resolve) => {
    setTimeout(resolve, delay);
  });
};
